import React, { useEffect, useState } from 'react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { DIALOG_TITLES } from '../../../constants';
import { useDialogs, useTaskForm } from '../../../hooks';
import Form from './Form';

const TaskFormDialog = () => {
  const [title, setTitle] = useState(DIALOG_TITLES.task.create);

  const { activeTask, showTaskFormDialog: showDialog } = useDialogs();

  const { errorMessage, form, handleOpenChange, handleSubmit, isSubmitting } =
    useTaskForm();

  useEffect(() => {
    if (showDialog) {
      setTitle(activeTask ? DIALOG_TITLES.task.update : DIALOG_TITLES.task.create);
    }
  }, [activeTask, showDialog]);

  return (
    <Dialog onOpenChange={handleOpenChange} open={showDialog}>
      <DialogContent className="sm:max-w-2xl gap-4">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <Form
          errorMessage={errorMessage}
          form={form}
          isSubmitting={isSubmitting}
          onSubmit={handleSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};

export default TaskFormDialog;
